import { Action } from 'redux';
import { push } from 'connected-react-router';
import { orCreate } from '../../../../../routes/utils/orCreate';

export const goToProject = (projectId?: string): Action => push(`/project/${orCreate(projectId)}`);
